import { render, staticRenderFns } from "./activity-promotion.vue?vue&type=template&id=12e3daf4&scoped=true&"
import script from "./activity-promotion.vue?vue&type=script&lang=js&"
export * from "./activity-promotion.vue?vue&type=script&lang=js&"
import style0 from "./activity-promotion.vue?vue&type=style&index=0&id=12e3daf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e3daf4",
  null
  
)

export default component.exports